import { Breadcrumb, Button, Col, DatePicker, Empty, Form, Input, message, Modal, Popover, Row, Select, Space, Spin, Table, Tag, Tooltip, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useReducer, useState } from 'react';
import { HomeOutlined, PlusOutlined, DeleteOutlined, FileTextOutlined } from '@ant-design/icons';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useAuth } from '../../Context';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import moment from 'moment';
import { useFormik } from 'formik';
import axios from 'axios';
import vspSurveyReducer from './reducer';
import { VSP_SURVEY_CREATE, VSP_SURVEY_CREATE_ERROR, VSP_SURVEY_CREATE_SUCCESS, VSP_SURVEY_DELETE, VSP_SURVEY_DELETE_ERROR, VSP_SURVEY_DELETE_SUCCESS, VSP_SURVEY_LIST, VSP_SURVEY_LIST_ERROR, VSP_SURVEY_LIST_SUCCESS } from './constants';

const { Title } = Typography;
const { RangePicker } = DatePicker;

// const unpack = (rows, key) => rows.map(row => row[key]);

export default function VSPSurveyDetails () {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	
	const initalState = {vspSurvey_data:[], loading: false, error: false, updateData : {} };
	const [data, dispatch] = useReducer(vspSurveyReducer, initalState);

	const { state } = useLocation();
	const navigate = useNavigate();

	// const [spin, setSpin] = useState(false);

	const [startDate, setStartDate] = useState(state && state.data && state.data.startDate ? state.data.startDate: moment.utc(new Date().setHours(0,0,0,0)).subtract({'days' : 30}).toISOString());
	const [endDate, setEndDate] = useState(state && state.data && state.data.endDate ? state.data.endDate: new Date().toISOString());

	const [wellFieldId, setwellFieldId] = useState(state && state.data && state.data.wellFieldId);
    
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [shotStartDate, setShotStartDate] = useState();
	const [deleteId, setDeleteId] = useState();
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [openvelocitiesDetails, setOpenVelocitiesDetails] = useState(false);
	const [velocitiesDetailViewValues, setvelocitiesDetailViewValues] = useState([{ layers: '', depths: '', velocities: '', offsets: '' }]);
	const [suveyseriesId, setSurveySeriesId] = useState(null);
	

	const { wellinfo, getWellInfo, wellFieldinfo, getWellFieldsInfo, surveySeriesinfo, getSurveySeriesInfo, surveySourceinfo, getSurveySourceInfo} = useAuth();

	const wellFieldFilterData = [];
	wellFieldFilterData.push({
		value : null,
		label : 'ALL'
	});
	const wellFieldData = [];
	wellFieldinfo && wellFieldinfo.map((item) => {
		wellFieldFilterData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		wellFieldData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
	});


	const suveySeriesDataFilter =[];
	suveySeriesDataFilter.push({
		value : null,
		label : 'ALL'
	});

	const suveySeriesData = [];
	surveySeriesinfo && surveySeriesinfo.map((item) => {

		suveySeriesDataFilter.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		suveySeriesData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		
	});

	const welldata =[];

	wellinfo && wellinfo.map((item) => {
		welldata.push({
			value : item.id,
			label : item.name.toUpperCase(),
			ip:item.ip,
			port :item.port
		});
		
	});

	const surveySourceData = [];
	surveySourceinfo && surveySourceinfo.map((item) => {
		surveySourceData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		
	});
	
	useEffect(() => {
		loadVSPSurveyData();		
	},[wellFieldId, startDate, endDate, suveyseriesId]);
	
	const loadVSPSurveyData = () => {
		dispatch({ type : VSP_SURVEY_LIST });
		let params = '';
		if(wellFieldId) {
			params += `&wellFieldId=${wellFieldId}`;
		}
		if (suveyseriesId){
			params += `&seriesId=${suveyseriesId}`;
		}
			
		if(startDate && endDate){
			params += `&shotDatetime[$gte]=${startDate}&shotDatetime[$lte]=${endDate}`;
		}
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:  `${api}/vspsurvey?$sort[id]=1${params}`,
			timeout: timeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`
			}
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : VSP_SURVEY_LIST_SUCCESS, payload : response.data});
				} else {
					dispatch({ type : VSP_SURVEY_LIST_ERROR });
				}
			})
			.catch((error) => {
				dispatch({ type : VSP_SURVEY_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	

	useEffect(() => {
		getWellFieldsInfo(authtoken);
		getSurveySeriesInfo(authtoken, null);

	},[]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	
	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());


	const showModal = () => {
		setIsModalOpen(true);
		getSurveySourceInfo(authtoken);
		getSurveySeriesInfo(authtoken, 'New');
	};
	const handleOk = () => {
		setIsModalOpen(false);
		setShowDeleteModal(false);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
		setShowDeleteModal(false);
		setOpenVelocitiesDetails(false);
		
	};

	const handleCancelAddModal =()=>{

		getSurveySeriesInfo(authtoken, null);
		setIsModalOpen(false);
	};

	const handleOkAddModal = () => {
		getSurveySeriesInfo(authtoken, null);
		setIsModalOpen(false);
	};


	const handleSetWellField = (value) => {
		setwellFieldId(value);
	};

	const disabledRangeTime = (currentDate) => {
		if (!currentDate) {
			return {};
		}
		
		const now = moment();
		
		// Disable future time slots on the current date
		if (currentDate.isSame(now, 'day')) {
			return {
				disabledHours: () => {
					const currentHour = now.hour();
					// Disable hours after the current hour
					return Array.from({ length: 24 }, (_, i) => (i > currentHour ? i : null)).filter(i => i !== null);
				},
				// disabledMinutes: () => {
				// 	const currentHour = now.hour();
				// 	const currentMinute = now.minute();
				// 	// Disable minutes after the current minute in the current hour
				// 	if (currentHour === now.hour()) {
				// 		return Array.from({ length: 60 }, (_, i) => (i > currentMinute ? i : null)).filter(i => i !== null);
				// 	}
				// 	return [];
				// },
				// disabledSeconds: () => {
				// 	const currentHour = now.hour();
				// 	const currentMinute = now.minute();
				// 	const currentSecond = now.second();
				// 	// Disable seconds after the current second in the current minute
				// 	if (currentHour === now.hour() && currentMinute === now.minute()) {
				// 		return Array.from({ length: 60 }, (_, i) => (i > currentSecond ? i : null)).filter(i => i !== null);
				// 	}
				// 	return [];
				// },
			};
		}
		
		// For future dates, allow all hours, minutes, and seconds
		return {};
	};

	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};

	const handleSetDate = (e) =>{
		if(e) {
			setStartDate(moment.utc(new Date(e[0] && e[0].$d)).toISOString());
			setEndDate(moment.utc(new Date(e[1] && e[1].$d)).toISOString());  
		} else {
			setStartDate(null);
			setEndDate(null);
		}
	};

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: null,
			sourceTypeId: null,
			seriesId: null,
			offsetDistance : null,
			shotDatetime : null,
			wellinfoId : null,
			wellFieldId : null,
			status : null,
			directory : '',
			fileName : '',
		},
		onSubmit: (value) => {

			const {name, sourceTypeId, seriesId, offsetDistance, wellinfoId, wellFieldId, directory, fileName} = value;
			if(name == null || sourceTypeId == null || seriesId == null || offsetDistance == null || shotStartDate == undefined || wellinfoId == null || wellFieldId == null
			) {
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}

			dispatch({ type : VSP_SURVEY_CREATE });

			let data = JSON.stringify({
				'name': name,
				'sourceTypeId': sourceTypeId,
				'seriesId': seriesId,
				'offsetDistance' : offsetDistance,
				'shotDatetime' : shotStartDate,
				'wellinfoId' : wellinfoId,
				'wellFieldId' : wellFieldId,
				'status' : 'New',
				'directory' : directory,
				'fileName' : fileName,
				'pipelineId': parseInt(pipelineId),
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/vspsurvey`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					'Authorization': `Bearer ${authtoken}`				
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201 ){
						Modal.success({ title: langdata && langdata.VSPsurveyaddedsuccessfully ? langdata.VSPsurveyaddedsuccessfully : 'VSPsurvey added successfully.' });
						loadVSPSurveyData();
						dispatch({ type : VSP_SURVEY_CREATE_SUCCESS });
					} else {
						Modal.warning({ title: langdata && langdata.VSPsurveynotadded ? langdata.VSPsurveynotadded : 'VSP survey not added.' });					
						dispatch({ type : VSP_SURVEY_CREATE_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : VSP_SURVEY_CREATE_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.VSPsurveynotadded ? langdata.VSPsurveynotadded : 'VSP survey not added.' });					
					}
				});

			setIsModalOpen(false);
			getSurveySeriesInfo(authtoken, null);
			
		}
	});	

	useEffect(()=>{
		if( state.data.wellFieldId || formik.values.wellFieldId){
			getWellInfo(authtoken, formik.values.wellFieldId ? formik.values.wellFieldId : state.data.wellFieldId);
		}
	},[formik.values.wellFieldId,state.data.wellFieldId]);

	const columns = [
		{
			title: `${langdata && langdata.Name ? langdata.Name:'Name'}`,
			dataIndex: 'name',
			key: 'name',
			//   render: (_,text) => <a onClick={showEditDrawer}>{text}</a>

		},
		
		{
			title: `${langdata && langdata.FieldName ? langdata.FieldName:'Field Name'}`,
			dataIndex: 'wellfields',
			key: 'wellfields',
		},
		{
			title: `${langdata && langdata.WellName ? langdata.WellName:'Well Name'}`,
			dataIndex: 'wellinfo',
			key: 'wellinfo',
		},
		{
			title: `${langdata && langdata.Offset ? langdata.Offset:'Offset'}`,
			dataIndex: 'offsetDistance',
			key: 'offsetDistance',
		},
		{
			title: `${langdata && langdata.ShotDateTime ? langdata.ShotDateTime:'Shot Date Time'}`,
			dataIndex: 'shotDatetime',
			key: 'shotDatetime',
		},
		{
			title: `${langdata && langdata.SurveySource ? langdata.SurveySource:'Survey Source'}`,
			dataIndex: 'sourceType',
			key: 'sourceType',
		},
		{
			title: `${langdata && langdata.SurveySeries ? langdata.SurveySeries:'Survey Series'}`,
			dataIndex: 'surveySeries',
			key: 'surveySeries',
		},
		{
			title: `${langdata && langdata.SurveyStatus ? langdata.SurveyStatus:'Survey Status'}`,
			dataIndex: 'surveyStatus',
			key: 'surveyStatus',
			render: (_, surveystatus) => (
				<>
					{surveystatus &&
						<Tag color={surveystatus.surveyStatus=='New' ? 'blue' : surveystatus.surveyStatus=='Inprogress' ? 'gold' : 
							surveystatus.surveyStatus=='Insufficient Data' ? 'gold' : surveystatus.surveyStatus=='Failed' ? 'red' : surveystatus.surveyStatus=='Completed' ? 'green' : 
								surveystatus.surveyStatus=='Inversion Completed' ? '#1e6ed6a8' : ''}>
							{surveystatus.surveyStatus}
						</Tag>}
				</>
			),
		},
		{
			title: `${langdata && langdata.Status ? langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',
			render: (_, status) => (
				<>
					{status &&
						<Tag color={status.status=='New' ? 'blue' : status.status=='Inprogress' ? 'gold' : 
							status.status=='Insufficient Data' ? 'gold' : status.status=='Failed' ? 'red' : status.status=='Completed' ? 'green' : ''}>
							{status.status}
						</Tag>}
				</>
			),
		},
		{
			title: `${langdata && langdata.Velocityms ? langdata.Velocityms:'Velocity (m/s)'}`,
			dataIndex: 'velocity',
			key: 'velocity',
			render: (velocities, options) => (				
				<Popover
					title={langdata && langdata.Velocitiesms ? langdata.Velocitiesms : 'Velocities (m/s)'}
					content={Array.isArray(velocities?.velocities) ? velocities?.velocities.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(velocities?.velocities) ?<a> {velocities?.velocities.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},
		{
			title: `${langdata && langdata.Directory ? langdata.Directory:'Directory'}`,
			dataIndex: 'directory',
			key: 'directory',
		},
		{
			title: `${langdata && langdata.FileName ? langdata.FileName:'FileName'}`,
			dataIndex: 'fileName',
			key: 'fileName',
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'action',
			align:'center',
			render: (_, record) => (
				<Space style={{justifyContent:'center',display:'flex'}} size="middle">
					<Button title={langdata && langdata.DeleteVSPSurvey ? langdata.DeleteVSPSurvey:'Delete VSP Survey'} type='link' disabled = {record.status == 'New' ? false : true}  onClick={() => {handleDeleteVSPSurvey(record);}}><DeleteOutlined/></Button>
				</Space>
			)
		}
    
	];

	const handleOpenDetails = (value) =>{		

		setOpenVelocitiesDetails(true);

		const depths = value?.velocity?.depths || [];
		const offsets = value?.velocity?.offsets || [];
		const velocities = value?.velocity?.velocities || [];
		const layers =  value?.velocity?.layers || [];
		
		const result = depths.map((startValue, idx) => ({
			depths: startValue,
			offsets: offsets[idx],
			velocities: velocities[idx],
			layers: layers[idx],
		}));
		setvelocitiesDetailViewValues(result);


	};

	const handleSetStartDate = (e) =>{
		if(e) {
			setShotStartDate(moment.utc(new Date(e && e.$d)).toISOString());
		} else {
			setShotStartDate(null);
		}
	};

	const handleDeleteVSPSurvey = (value) => {
		setDeleteId(value.id);
		setShowDeleteModal(true);
	};	
	
	const handleDelete = () => {
		dispatch({ type : VSP_SURVEY_DELETE });
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/vspsurvey/${deleteId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};

		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					loadVSPSurveyData();
					dispatch({ type : VSP_SURVEY_DELETE_SUCCESS });
					Modal.success({ title: langdata && langdata.VSPsurveydeletedsuccessfully ? langdata.VSPsurveydeletedsuccessfully : 'VSP survey deleted successfully.' });					
				} else {
					dispatch({ type : VSP_SURVEY_DELETE_ERROR });
					Modal.warning({ title: langdata && langdata.VSPsurveynotdeleted ? langdata.VSPsurveynotdeleted : 'VSP survey not deleted.' });					
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : VSP_SURVEY_DELETE_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.VSPsurveynotdeleted ? langdata.VSPsurveynotdeleted : 'VSP survey not deleted.' });
				}
			});
		setShowDeleteModal(false);
	};	


	const handleAddSurveySeries = () =>{
		navigate(( '/survey-series'),{ state: { data: {showAddModal:true}, path: 'vsp-survey-details' } });
	};

	const handleSetSurveySeries = (e) =>{
		setSurveySeriesId(e);
	};

	const handleInversion = ()=>{
		navigate('/vsp-survey-inversion');
	};

	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >

					<Col span={6}>
						<Row>
							<Space>
								<FileTextOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							{/* <Col style={{marginLeft:'4px'}} span={19}> */}
							<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails : 'VSP Survey Details'}</Title>
							<Space>&nbsp;&nbsp;</Space>
						</Row>
					</Col>
					<Col span={18}>
						<Row justify="end">
							<Col>
								{/* <Tooltip placement="bottom" title={langdata && langdata.FilterbyWell ? langdata.FilterbyWell : 'Filter by well'}>
									<Space>
										<Select
											style={{minWidth: '150px', maxWidth:'150px', margin:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.SelectWell ? langdata.SelectWell : 'Select Well'}
											optionFilterProp="children"
											value={wellId}
											options={welldata}
											onSelect={(e, options)=>handleSetWell(e, options)}
										/>
									</Space>
								</Tooltip>
								<Space>&nbsp;</Space>	
								<Tooltip placement="bottom" title={langdata && langdata.Filterbychannel ? langdata.Filterbychannel : 'Filter by channel'}>
									<Select
										style={{ minWidth: '150px', maxWidth:'150px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectChannel ? langdata.SelectChannel : 'Select Channel'}
										optionFilterProp="children"
										defaultValuevalue={null}
										value={channelId}
										options={channellist}
										onSelect={(value)=>handleSetChannel(value)}
									/>
								</Tooltip>
								<Space>&nbsp;</Space> */}
								<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthedateandtime ? langdata.Pleaseselectthedateandtime :'Please select the date and time'}>
									<RangePicker 
										showTime ={{hideDisabledOptions: true, format : 'YYYY-MM-DD HH'}} 
										style={{ width: '300px',margin:'5px'}}
										defaultValue={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
										format={settingsdateformat + ' ' + settingstimeformat}
										placeholder={[langdata && langdata.Startdateandtime ? langdata.Startdateandtime : 'Start date and time', langdata && langdata.Enddateandtime ? langdata.Enddateandtime : 'End date and time']}
										disabledDate={disabledDate}
										disabledTime={disabledRangeTime}
										onChange={handleSetDate}
										allowClear={true} />
								</Tooltip>
								<Space>&nbsp;</Space>
								<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield :'Please select the well field'}>
									<Select
										style={{ minWidth: '150px', maxWidth:'150px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'}
										optionFilterProp="children"
										defaultValuevalue={null}
										value={wellFieldId}
										options={wellFieldFilterData}
										onSelect={(value)=>handleSetWellField(value)}
									/>
								</Tooltip>
								<Space>&nbsp;</Space>

								<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series'}>
									<Space>
										<Select
											style={{ width: '180px', margin:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series'}
											optionFilterProp="children"
											value={suveyseriesId}
											options={suveySeriesDataFilter}
											onSelect={(e, options)=>handleSetSurveySeries(e, options)}
										/>
									</Space>
								</Tooltip>
								<Space>&nbsp;</Space>
															
								<Tooltip placement="bottom" title={langdata && langdata.SurveySeries ? langdata.SurveySeries:'Survey Series'}>
									<Button
										style={{ margin:'5px' }}
										type='primary'
										onClick={handleAddSurveySeries}
									><PlusOutlined/>{langdata && langdata.SurveySeries ? langdata.SurveySeries:'Survey Series'}</Button>
								</Tooltip>
								<Space>&nbsp;</Space>
								<Tooltip placement="bottom" title={langdata && langdata.AddNew ? langdata.AddNew:'Add New'}>
									<Button
										style={{ margin:'5px' }}
										type='primary'
										onClick={showModal}
									><PlusOutlined/>{langdata && langdata.New ? langdata.New:'New'}</Button>
								</Tooltip>
								<Space>&nbsp;</Space>
								<Tooltip placement="bottom" title={langdata && langdata.Inversion ? langdata.Inversion:'Inversion'}>
									<Button
										style={{ margin:'5px' }}
										type='primary'
										onClick={handleInversion}
									>{langdata && langdata.Inversion ? langdata.Inversion:'Inversion'}</Button>
								</Tooltip>					
							</Col>
						</Row>
					</Col>
				</Row>
				<Row style={{
					margin: '10px',
					// marginTop : '5px',
					// paddingLeft: '10px',
					// paddingRight: '10px',
					// background: '#FFFFFF',
					alignItems:'center',
				}}  >
					<Col>
						<Breadcrumb
							items={[
								{
									href: '/dashboard',
									title: <HomeOutlined />,
								},
								{
									title: ( state && state.path === 'well-visualization' ? <a onClick={()=>{navigate(-2);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a> :  <a onClick={()=>{navigate(-2);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a>)
								},
								{
									title: ( state && state.path === 'vsp-survey' ? <a onClick={()=>{navigate(-1);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a> :  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a>)
								},
								{
									title: `${langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails : 'VSP Survey Details'}`,
								},
							]}
							// style={{ marginBottom : '10px'}}
						/>
					</Col>
				</Row>

				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{data.vspSurvey_data.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.vspSurvey_data}/>
							: 
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)
						}
					</Col>
				</Row>
				
			</Content>
			<Modal 
				title={langdata && langdata.AddVSPSurvey ? langdata.AddVSPSurvey : 'Add VSP Survey' } 
				destroyOnClose= {true}
				maskClosable= {false}
				open={isModalOpen} 
				width={800}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancelAddModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary" onClick={formik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				onOk={handleOkAddModal} 
				onCancel={handleCancelAddModal}>
				<Form layout="vertical">
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} name='name' rules={[{ required: true, message : langdata && langdata.Enterthename ? langdata.Enterthename : 'Enter the name' }]}> 
								<Input 
									type='text' 
									placeholder={langdata && langdata.Enterthename ? langdata.Enterthename : 'Enter the name'}
									onChange={formik.handleChange}
								/>		
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'} name="wellFieldId" rules={[{ required: true, message : langdata && langdata.Pleaseenterthefieldname ? langdata.Pleaseenterthefieldname : 'Please enter the field name' }]}> 
								{/* <Input 
									placeholder={langdata && langdata.Selecttheseismictype ? langdata.Selecttheseismictype : 'Select the seismic type'}
									onChange={formik.handleChange}
								/> */}
								<Select
									// style={{ width: '180px',margin:'5px'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.Pleaseenterthefieldname ? langdata.Pleaseenterthefieldname : 'Please enter the field name'}
									optionFilterProp="children"
									defaultValue={formik.values.wellFieldId}
									options={wellFieldData}
									onChange={(value) => formik.setFieldValue('wellFieldId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.WellName ? langdata.WellName : 'Well Name'} name="wellName" rules={[{ required: true, message : langdata && langdata.SelecttheWellname ? langdata.SelecttheWellname : 'Select the Well name' }]}> 
								{/* <Input 
									placeholder={langdata && langdata.Selecttheseismictype ? langdata.Selecttheseismictype : 'Select the seismic type'}
									onChange={formik.handleChange}
								/> */}
								<Select
									// style={{ width: '180px',margin:'5px'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelecttheWellname ? langdata.SelecttheWellname : 'Select the Well name'}
									optionFilterProp="children"
									defaultValue={formik.values.wellinfoId}
									options={welldata}
									onChange={(value) => formik.setFieldValue('wellinfoId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.SurveySource ? langdata.SurveySource : 'Survey Source'} name="sourceTypeId" rules={[{ required: true, message : langdata && langdata.Pleaseselectthesurveysource ? langdata.Pleaseselectthesurveysource : 'Please select the survey source' }]}> 
								{/* <Input 
									placeholder={langdata && langdata.Selecttheseismictype ? langdata.Selecttheseismictype : 'Select the seismic type'}
									onChange={formik.handleChange}
								/> */}
								<Select
									// style={{ width: '180px',margin:'5px'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.Pleaseselectthesurveysource ? langdata.Pleaseselectthesurveysource : 'Please select the survey source'}
									optionFilterProp="children"
									defaultValuevalue={null}
									options={surveySourceData}
									onChange={(value) => formik.setFieldValue('sourceTypeId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.SurveySeries ? langdata.SurveySeries : 'Survey Series'} name="seriesId" rules={[{ required: true, message : langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series' }]}> 
								{/* <Input 
									placeholder={langdata && langdata.Selecttheseismictype ? langdata.Selecttheseismictype : 'Select the seismic type'}
									onChange={formik.handleChange}
								/> */}
								<Select
									// style={{ width: '180px',margin:'5px'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series'}
									optionFilterProp="children"
									defaultValuevalue={null}
									options={suveySeriesData}
									onChange={(value) => formik.setFieldValue('seriesId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Offsetfromthewell ? langdata.Offsetfromthewell + ' (m)': 'Offset from the well (m)'} name='offsetDistance' rules={[{ required: true, message : langdata && langdata.Pleaseentertheoffsetdistance ? langdata.Pleaseentertheoffsetdistance : 'Please enter the offset distance' }]}> 
								<Input 
									type='number' 
									placeholder={langdata && langdata.Pleaseentertheoffsetdistance ? langdata.Pleaseentertheoffsetdistance : 'Please enter the offset distance'}
									onChange={formik.handleChange}
								/>		
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.ShotDateTime ? langdata.ShotDateTime : 'Shot Date Time'} name="shotDatetime" rules={[{ required: true, message : langdata && langdata.Pleaseselectthedateandtime ? langdata.Pleaseselectthedateandtime :'Please select the date and time' }]}> 
								<DatePicker
									style={{ width : '100%'}}
									showTime
									placeholder={langdata && langdata.Pleaseselectthedateandtime ? langdata.Pleaseselectthedateandtime :'Please select the date and time'}
									onChange={handleSetStartDate}
									disabledDate={disabledDate}
									disabledTime={disabledRangeTime}
									// onOk={onOk}
								/>								
							</Form.Item>
						</Col>
					</Row>					
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.Directory ? langdata.Directory : 'Directory'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory' }]}>
								<Input 
									name="directory" 
									placeholder={langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory'}
									onChange={formik.handleChange} 
									value={formik.values.directory}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.FileName ? langdata.FileName : 'File Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter file name' }]}>
								<Input 
									name="fileName" 
									placeholder={langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter the file name'}
									onChange={formik.handleChange} 
									value={formik.values.fileName}
								/>
							</Form.Item>
						</Col>
					</Row>
				
				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={showDeleteModal} onOk={handleOk} onCancel={handleCancel}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis :'Are you sure you want to delete this ?'}</Col>
				</Row>
			</Modal>

			<Modal
				title={langdata && langdata.Details ? langdata.Details : 'Details'}
				centered
				open={openvelocitiesDetails}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
					</Space>
				]}
				width={800}
			>

				<Form layout="vertical" >

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Details ? langdata.Details:'Details'}</b></Typography>
						</Col>
					</Row>

					{velocitiesDetailViewValues.map((input, index) => (						
						
						<Row gutter={24} key={index}>
							<Col span={7}>
								<Form.Item
									label={langdata?.Layers || 'Layers'}
									
								>
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										disabled
										placeholder={langdata?.Pleaseenterthelayername || 'Please enter the layer name'}									
										value={input.layers && input.layers !== '' ? input.layers : null}
									/>
								</Form.Item>
							</Col>
							<Col span={6}>
								<Form.Item
									label={langdata?.Depths || 'Depths'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										type='number'
										min={0}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseselectthedepth || 'Please select the depth'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										disabled
										value={input.depths && input.depths !== '' ? input.depths : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
									/>
								</Form.Item>
							</Col>

							<Col span={5}>
								<Form.Item
									label={langdata?.Velocitiesms || 'Velocities (m/s)'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayervelocity || 'Please enter the layer velocity'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										disabled
										value={input.velocities && input.velocities !== '' ? input.velocities : null}
									/>
								</Form.Item>
							</Col>

							<Col span={6}>
								<Form.Item
									label={langdata?.OffsetDistance || 'Offset Distance (m)'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayerdensity || 'Please enter the layer density'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										disabled
										value={input.offsets && input.offsets !== '' ? input.offsets : null}
									/>
								</Form.Item>
							</Col>

							
						</Row>
							
					))}
				</Form>
			</Modal>

			<Spin fullscreen spinning={false} />

			{/* Add Vulnerable Point Details Modal Starts */}
			
			{/* Delete User Modal Ends */}
		</>
	);
}